import React, { Component, Fragment } from "react";

import classNames from "classnames";
import * as style from "./StudentReg.css";
import { generateId, pageSettingAndLangSupport } from "../shared/utils";
import i18n from "../shared/i18n/i18n";

import Spinner from "../SharedComponent/Spinner/Spinner";
import Message from "../SharedComponent/Message/Message";
import HeaderGuest from "../SharedComponent/HeaderGuest/HeaderGuest";
import PersonalDataAgreement from "../SharedComponent/PersonalDataAgreement/PersonalDataAgreement";
import Form from "../StudentReg/Form/Form";
import FieldText from "../SharedComponent/FieldText/FieldText";

export default class StudentReg extends Component {
  constructor(props) {
    super(props);

    this.state = {
      confirmationCode: "",
      confirmationEmail: "",
      regButtonEnabled: false,
    };

    this.ui = {
      regButton: React.createRef(),
      spinner: React.createRef(),
      message: React.createRef(),
      headerGuest: React.createRef(),
      form: React.createRef(),
      confirmationCode: React.createRef(),
    };

    this.onRegister = this.onRegister.bind(this);
    this.sendConfirmationCode = this.sendConfirmationCode.bind(this);

    pageSettingAndLangSupport(this);
  }

  componentDidMount() {
    this.ui.form.current.setData({
      student: {
        login: "",
        password: "",
        email: "",
        knowFrom: -1,
        phone: "",
        names: {
          firstName: "",
          lastName: "",
          middleName: "",
          birthdate: "",
          gender: "M",
        },
        typeIdCard: "BIRTH",
        idCard: {
          series: "",
          number: "",
          dateOfIssue: "",
          authority: "",
          insuranceNumer: "",
        },
        location: {
          country: {
            value: 0,
          },
          region: {
            value: 0,
            data: null,
          },
          city: {
            value: "",
            data: null,
          },
        },
        postalCode: "",
        address: "",
        school: {
          startYear: 0,
          classId: -1,
          locationType: false,
          location: {
            country: {
              value: 0,
            },
            region: {
              value: 0,
              data: null,
            },
            city: {
              value: "",
              data: null,
            },
          },
          name: "",
          id: 0,
        },
      },
      studentAgent: {
        email: "",
        phone: "",
        names: {
          firstName: "",
          lastName: "",
          middleName: "",
          birthdate: "",
          gender: "F",
        },
        idCard: {
          series: "",
          number: "",
          dateOfIssue: "",
          authority: "",
          insuranceNumer: "",
        },
        location: {
          country: {
            value: 0,
          },
          region: {
            value: 0,
            data: null,
          },
          city: {
            value: "",
            data: null,
          },
        },
        postalCode: "",
        address: "",
      },
      social: {
        statusLargeFamily: "NO",
        hasFileLargeFamily: false,
        statusPoorFamily: "NO",
        hasFilePoorFamily: false,
        statusSingleParentFamily: "NO",
        hasFileSingleParentFamily: false,
        statusDisabilityMember: "NO",
        hasFileDisabilityMember: false,
        statusMiddleTownInhabitant: "NO",
        statusSmallTownInhabitant: "NO",
        statusCountrysideInhabitant: "NO",
        statusRefugeeFamily: "NO",
        hasFileRefugeeFamily: false,
      },
    });
  }

  onRegister() {
    if (this.ui.form.current.check()) {
      let payload = this.ui.form.current.getData();

      if ( true || (
        payload.student.email === this.state.confirmationEmail &&
        this.state.confirmationCode.length > 0 &&
        this.state.confirmationCode ===
          this.ui.confirmationCode.current.getValue()
        )
      ) {
        // this.ui.confirmationCode.current.setError("");

        this.ui.message.current.hide();
        this.ui.spinner.current.show();

        let body = new FormData();
        if (
          payload.social.fileLargeFamily.hasFile &&
          payload.social.fileLargeFamily.file
        ) {
          body.append(
            "file[]",
            payload.social.fileLargeFamily.file,
            JSON.stringify({
              fileName: payload.social.fileLargeFamily.file.name,
              type: "large_family",
            })
          );
        }
        payload.social.hasFileLargeFamily =
          payload.social.fileLargeFamily.hasFile;
        delete payload.social.fileLargeFamily;

        if (
          payload.social.filePoorFamily.hasFile &&
          payload.social.filePoorFamily.file
        ) {
          body.append(
            "file[]",
            payload.social.filePoorFamily.file,
            JSON.stringify({
              fileName: payload.social.filePoorFamily.file.name,
              type: "poor_family",
            })
          );
        }
        payload.social.hasFilePoorFamily =
          payload.social.filePoorFamily.hasFile;
        delete payload.social.filePoorFamily;

        if (
          payload.social.fileSingleParentFamily.hasFile &&
          payload.social.fileSingleParentFamily.file
        ) {
          body.append(
            "file[]",
            payload.social.fileSingleParentFamily.file,
            JSON.stringify({
              fileName: payload.social.fileSingleParentFamily.file.name,
              type: "single_parent_family",
            })
          );
        }
        payload.social.hasFileSingleParentFamily =
          payload.social.fileSingleParentFamily.hasFile;
        delete payload.social.fileSingleParentFamily;

        if (
          payload.social.fileDisabilityMember.hasFile &&
          payload.social.fileDisabilityMember.file
        ) {
          body.append(
            "file[]",
            payload.social.fileDisabilityMember.file,
            JSON.stringify({
              fileName: payload.social.fileDisabilityMember.file.name,
              type: "disability_member",
            })
          );
        }
        payload.social.hasFileDisabilityMember =
          payload.social.fileDisabilityMember.hasFile;
        delete payload.social.fileDisabilityMember;

        if (
          payload.social.fileRefugeeFamily.hasFile &&
          payload.social.fileRefugeeFamily.file
        ) {
          body.append(
            "file[]",
            payload.social.fileRefugeeFamily.file,
            JSON.stringify({
              fileName: payload.social.fileRefugeeFamily.file.name,
              type: "refugee_family",
            })
          );
        }
        payload.social.hasFileRefugeeFamily =
          payload.social.fileRefugeeFamily.hasFile;
        delete payload.social.fileRefugeeFamily;

        body.append("action", JSON.stringify("registerStudent"));
        body.append("payload", JSON.stringify(payload));

        fetch("api/request.php", {
          method: "POST",
          mode: "cors",
          credentials: "include",
          body,
        })
          .then(response => {
            return response.json();
          })
          .then(json => {
            if (json.type !== 0) {
              this.ui.spinner.current.hide();
              this.ui.message.current.setMessage(json.code, "danger", false);
              return;
            }

            window.location.href =
              "messageGuest.php?lang=" +
              this.props.setting.lang +
              "&message=NOTE_THANK_FOR_REGISTRATION";
          })
          .catch(error => {
            debugger;
            this.ui.spinner.current.hide();
            this.ui.message.current.setMessage("ERR_UNKNOWN", "danger", false);
          });
      } else if (
        payload.student.email === this.state.confirmationEmail &&
        this.state.confirmationCode.length > 0 &&
        this.state.confirmationCode !==
          this.ui.confirmationCode.current.getValue()
      ) {
        this.ui.confirmationCode.current.setError(
          "NOTE_CONFIRMATION_CODE_WRONG"
        );
      } else {
        this.sendConfirmationCode(payload.student.email);
      }
    }
  }

  sendConfirmationCode(email) {
    this.ui.message.current.hide();
    this.ui.spinner.current.show();

    fetch("api/request.php", {
      method: "POST",
      mode: "cors",
      credentials: "include",
      body: JSON.stringify({
        action: "sendConfirmationCode",
        payload: { email },
      }),
    })
      .then(response => {
        return response.json();
      })
      .then(json => {
        if (json.type !== 0) {
          this.ui.spinner.current.hide();
          this.ui.message.current.setMessage(json.code, "danger", false);
          return;
        }

        this.setState(
          {
            confirmationCode: json.data,
            confirmationEmail: email,
          },
          function () {
            this.ui.confirmationCode.current.setError("");
            this.ui.confirmationCode.current.setValue("");
            this.ui.confirmationCode.current.focus();
          }
        );

        this.ui.spinner.current.hide();
        this.ui.message.current.setMessage(
          "NOTE_CONFIRMATION_CODE_SENT",
          "info",
          false
        );
      })
      .catch(error => {
        debugger;
        this.ui.spinner.current.hide();
        this.ui.message.current.setMessage("ERR_UNKNOWN", "danger", false);
      });
  }

  render() {
    return (
      <div className="fb-col">
        <Spinner ref={this.ui.spinner} />
        <HeaderGuest
          ref={this.ui.headerGuest}
          setting={this.props.setting}
          spinner={this.ui.spinner}
          message={this.ui.message}
        />
        <div
          className={classNames("fb-row fb-sb-c p1rem menu-bound", style.menu)}
        >
          <div className="fz-15rem">
            {i18n("REGISTRATION_STUDENT", this.props.setting.lang)}
          </div>
          <div className="fb-row">
            {this.state.confirmationCode.length > 0 && (
              <FieldText
                ref={this.ui.confirmationCode}
                setting={this.props.setting}
                option={{
                  type: "text",
                  size: 20,
                  className: "p0",
                  inputClassName: style["confirmation-code"],
                  placeholder: i18n(
                    "CONFIRMATION_CODE",
                    this.props.setting.lang
                  ),
                }}
              />
            )}
            <button
              ref={this.ui.regButton}
              className="btn btn-success fb-self-e"
              onClick={e => this.onRegister()}
              disabled={!this.state.regButtonEnabled}
            >
              {i18n("VERB_REGISTER", this.props.setting.lang)}
            </button>
          </div>
        </div>
        <Message
          ref={this.ui.message}
          hasPlace={true}
          setting={this.props.setting}
        />
        <PersonalDataAgreement
          setting={this.props.setting}
          option={{
            isShort: false,
            onChange: value => {
              this.setState({ regButtonEnabled: value });
            },
          }}
        />
        <Form
          ref={this.ui.form}
          setting={this.props.setting}
          spinner={this.ui.spinner}
          message={this.ui.message}
        />
      </div>
    );
  }
}
